// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/components/message/tooltips/ChatFlowInboxAccessTooltip.tsx
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { getInboxAccessUrl } from '../../../urls/inbox-urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChatFlowInboxAccessTooltip = props => {
  const href = getInboxAccessUrl(props.inboxId);
  const title = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "routing-ui.users-and-teams.tooltips.inbox_access_jsx",
    elements: {
      Link
    },
    options: {
      external: true,
      href
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.users-and-teams.groups.user"
    }), /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: title
    })]
  });
};
ChatFlowInboxAccessTooltip.displayName = 'ChatFlowInboxAccessTooltip';
export default ChatFlowInboxAccessTooltip;